<template>
  <BContainer class="h-100">
    <div
      v-if="error"
      key="error"
      class="p-5"
    >
      <BError>{{ error }}</BError>
    </div>

    <div
      v-else
      key="loading"
      class="bc-spinner"
    />
  </BContainer>
</template>

<script setup lang="ts">
import {ref, getCurrentInstance, onBeforeMount} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import BError from '@/components/ui/BError.vue'

const route = useRoute()
const router = useRouter()
const instance = getCurrentInstance()

const error = ref<string | null>(null)

const emit = defineEmits<{(e: 'authenticated'): void
}>()

onBeforeMount(async () => {
  const auth = instance?.appContext.config.globalProperties.$auth
  error.value = (route.query.error_description as string) || null
  if (route.query.code && (route.query.code as string).length > 0) {
    try {
      await auth.handleLoginRedirect()
      emit('authenticated')
    } catch (e: any) {
      error.value = e.message
    }
  } else {
    if (error.value) {
      router.push({name: 'Error', query: {'error': 'oktaUnauthorized', 'message': error.value}})
    } else {
      router.push('/')
    }
  }
})
</script>

<style lang="scss" scoped>
.page {
  padding-top: 4rem;
}
</style>
